export default __webpack_public_path__ + "static/media/kia.304e06f1.webp";